/**
 * SEO Content Block — collapsible <details>/<summary> accordion
 * Crawlable by Google, styled as subtle footer-level prose.
 * Uses native HTML5 disclosure widget — no JS needed.
 */
export default function SEOContentBlock({ title, children }) {
  return (
    <section className="border-t border-gray-800 bg-black" data-testid="seo-content-block">
      <div className="max-w-4xl mx-auto px-6 py-8">
        <details className="group">
          <summary className="cursor-pointer text-xs uppercase tracking-widest text-gray-500 hover:text-gray-400 transition-colors select-none list-none flex items-center gap-2">
            <svg
              className="w-3 h-3 transition-transform group-open:rotate-90"
              fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
            </svg>
            {title || 'Learn More About Our Technology'}
          </summary>
          <div className="mt-4 text-xs leading-relaxed text-gray-500 space-y-3">
            {children}
          </div>
        </details>
      </div>
    </section>
  );
}
